import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";

import { MDButton } from "@/components/atoms/MDButton";
import MDTypography from "@/components/atoms/MDTypography";
import { OrderPaymentMessages } from "@/messages/order-details/order-payment.messages";

type Props = {
  open: boolean;
  onClose: () => void;
  paymentComments: string;
  messages: OrderPaymentMessages;
};

export default function PaymentDetailsModal({ open, onClose, paymentComments, messages }: Props) {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>{messages.paymentDetailsModalTitle}</DialogTitle>
      <DialogContent dividers>
        <MDTypography
          variant="body2"
          component="pre"
          sx={{ whiteSpace: "pre-wrap", fontFamily: "inherit", margin: 0 }}
        >
          {paymentComments}
        </MDTypography>
      </DialogContent>
      <DialogActions>
        <MDButton variant="outlined" color="dark" onClick={onClose}>
          {messages.paymentDetailsModalCloseLabel}
        </MDButton>
      </DialogActions>
    </Dialog>
  );
}
